import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import useTranslation from "../Languages/Translation";

import {
  useDisconnect,
  useWeb3Modal,
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from "@web3modal/ethers/react";

import piku from "../assets/images/homePage/piku.svg";
// import usdt from "../assets/images/homePage/USDT.svg";
import usdc from "../assets/images/homePage/USDC.svg";
import polygon from "../assets/images/homePage/polygon.svg";
import logo from "../assets/images/homePage/Headerlogo.svg";
import arbitrum from "../assets/images/homePage/arbitrum.svg";
import avalanche from "../assets/images/homePage/avalanche.svg";
import back from "../assets/images/homePage/Blur_Background.png";
import mobile_background from "../assets/images/homePage/mobile_background.png";

import seearrow from "../assets/images/homePage/home_right_arrow.png";
import ckeck from "../assets/images/homePage/header_dropdown_check.svg";
import copy from "../assets/images/homePage/reserve_wallet_copy_drpdwn.svg";
import header_rhs_1 from "../assets/images/homePage/header_rhs_icon_1.svg";
import header_rhs_2 from "../assets/images/homePage/header_rhs_icon_2.svg";
import menu from "../assets/images/overview/menu.png";
import mobilecrypto from "../assets/images/overview/mobilecrypto.png";
import sidebarcross from "../assets/images/overview/sidebarcross.png";
import { GovernceLists } from "../config";
import {
  isUserWhiteListed,
  updateAllBalances,
} from "../Service/Web3/Web3Service";
import { ethers } from "ethers";
import { useWeb3Context } from "../Service/Web3/Web3Context";

function Header() {
  const history = useNavigate();
  const location = useLocation();
  const translation = useTranslation();
  const [copySuccess, setCopySuccess] = useState("");
  const [ethBalance, setETHBalance] = useState(0);
  const [usdcBalance, setUSDCBalance] = useState(0);
  const [pikuBalance, setPikuBalance] = useState(0);
  const [pikuPrice, setPikuPrice] = useState(0);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [governanceMobile, setgovernanceMobile] = useState(false);

  const [select, setSelect] = useState("eth");
  const [dropDown, setDropdown] = useState(false);
  const [dropDownCopy, setDropdownCopy] = useState(false);

  const popupRef_1 = useRef(null);
  const popupRef_2 = useRef(null);

  const { open } = useWeb3Modal();
  const { disconnect } = useDisconnect();
  const { walletProvider } = useWeb3ModalProvider();
  const { isConnected, address } = useWeb3ModalAccount();

  const { refresh } = useWeb3Context();

  const handleopenSidebar = () => {
    setOpenSidebar(true);
    document.body.style.overflow = "hidden"; // Disable scrolling
  };

  const handlecloseSidebar = () => {
    setOpenSidebar(false);
    document.body.style.overflow = "auto"; // Enable scrolling
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef_1.current && !popupRef_1.current.contains(event.target)) {
        setDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [popupRef_1]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef_2.current && !popupRef_2.current.contains(event.target)) {
        setDropdownCopy(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [popupRef_2]);

  const headerDropDown_1 = () => {
    setDropdown(!dropDown);
    setDropdownCopy(false);
    document.body.style.overflow = "hidden"; // Disable scrolling
  };

  const headerDropDown_2 = () => {
    setDropdownCopy(!dropDownCopy);
    setDropdown(false);
  };

  const closeDropdown = () => {
    setDropdownCopy(false);
    setDropdown(false);
  };

  const copyToClipBoard = async (copyMe) => {
    try {
      await navigator?.clipboard?.writeText(copyMe);
      setCopySuccess("Copied!");
    } catch (err) {
      setCopySuccess("Failed to copy!");
    }
  };

  const load = async () => {
    const provider = new ethers.BrowserProvider(walletProvider);
    const signer = await provider.getSigner();
    const eth_balance = await provider.getBalance(address);
    console.log("Wallet connected. Address:", address);

    const { usdc_balance, piku_balance, piku_price } = await updateAllBalances(
      signer,
      address
    );

    setUSDCBalance(usdc_balance);
    setPikuBalance(piku_balance);
    setETHBalance(eth_balance);
    setPikuPrice(piku_price);

    if (await isUserWhiteListed(signer)) {
      localStorage.setItem(
        "kycdetail",
        JSON.stringify({
          isWhiteListed: true,
        })
      );
      history("/overview");
    } else {
      history("/overview");
    }
  };

  useEffect(() => {
    if (dropDown) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Disable scrolling
    }
  }, [dropDown]);

  useEffect(() => {
    if (dropDownCopy) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Disable scrolling
    }
  }, [dropDownCopy]);

  useEffect(() => {
    if (isConnected && address && walletProvider) {
      load();
    }
  }, [isConnected, address, walletProvider, refresh]);

  const governcelist = [
    {
      name: "Lock",
    },
    {
      name: "Vote",
    },
    {
      name: "Delegation",
    },
    {
      name: "Stats",
    },
  ];
  return (
    <>
      {location.pathname !== "/" && (
        <div className=" absolute top-[73px] lg:top-0 left-0 right-0 z-[-1]">
          <img src={back} alt="back" className=" hidden lg:block"></img>
          <img
            src={mobile_background}
            alt="back"
            className=" lg:hidden w-full"
          ></img>
        </div>
      )}
      <div
        className={`px-[10px] sm:px-[20px] md:px-[40px] flex items-center justify-between ${
          isConnected ? "py-[11.5px]" : "py-[30px]"
        } absolute w-full top-0`}
      >
        <div className=" flex items-center">
          <div className="flex items-center">
            <Link to="/">
              <img
                src={logo}
                alt="logo"
                className="cursor-pointer"
                onClick={() => closeDropdown()}
              ></img>
            </Link>
          </div>

          {isConnected && (
            <div className="hidden lg:flex items-center justify-between top-0">
              <div className="flex items-center ml-[48px]">
                <ul className="flex items-center">
                  <Link to="/overview">
                    <li
                      onClick={() => closeDropdown()}
                      className={`text-[16px] aeonik_medium leading-[24px] cursor-pointer rounded-[12px] px-[12px] py-[4px] ${
                        location.pathname === "/overview"
                          ? "text-[#26DDF9] bg-[#062025]"
                          : " text-white"
                      } hover:text-[#26DDF9] hover:bg-[#062025]`}
                    >
                      {translation.Overview}
                    </li>
                  </Link>
                  <li
                    onClick={() => closeDropdown()}
                    className="text-[16px] text-white aeonik_medium leading-[24px] cursor-pointer rounded-[12px] mx-[8px] px-[12px] py-[4px]   hover:text-[#26DDF9] hover:bg-[#062025]"
                  >
                    {translation.Docs}
                  </li>
                  <li
                    onClick={() => closeDropdown()}
                    className="text-[16px] text-white aeonik_medium leading-[24px] cursor-pointer rounded-[12px] px-[12px] py-[4px] hover:text-[#26DDF9] hover:bg-[#062025]"
                  >
                    {translation.Community}
                  </li>
                  <li
                    onClick={() => closeDropdown()}
                    className="text-[16px] text-white  relative hover:bg-[#222] gov_menu aeonik_medium leading-[24px] cursor-pointer rounded-[12px] mx-[8px] px-[12px] py-[4px] flex items-center"
                  >
                    <span className="mr-[4px]">{translation.Governance}</span>
                    <img
                      src={seearrow}
                      alt="down arrow"
                      className="h-[14px] w-auto object-contain transform rotate-90 "
                    />
                    <ul className="min-w-[260px] rounded-[16px] shadow-xl  p-[8px] bg-[#222222] z-[100] absolute top-[33px] left-0 gov_sub_item">
                      {GovernceLists.map((m, i) => (
                        <Link
                          to={`/governance/${m.name?.toLowerCase()}`}
                          key={i}
                        >
                          <li className=" text-[14px] text-white aeonik_medium leading-[21px] rounded-[8px] px-[14px] py-[8px] hover:bg-[#2f2f2f]">
                            {m.name}
                          </li>
                        </Link>
                      ))}
                    </ul>
                  </li>
                  <Link to="/governance/claim">
                    <li
                      onClick={() => closeDropdown()}
                      className={`text-[16px] aeonik_medium leading-[24px] cursor-pointer rounded-[12px] px-[12px] py-[4px]  ${
                        location.pathname === "/governance/claim"
                          ? "text-[#26DDF9] bg-[#062025]"
                          : "text-white"
                      } hover:text-[#26DDF9] hover:bg-[#062025]`}
                    >
                      {translation.Claim}
                    </li>
                  </Link>
                </ul>
              </div>
            </div>
          )}
        </div>

        {isConnected ? (
          <div className="flex items-center">
            <div
              className=" relative px-[10px] py-[6px] mr-[8px] lg:mr-[16px] bg-[#151718] rounded-[24px] cursor-pointer "
              ref={popupRef_1}
            >
              <div className="flex items-center" onClick={headerDropDown_1}>
                <img
                  src={
                    (select === "eth" && header_rhs_1) ||
                    (select === "arb" && arbitrum) ||
                    (select === "ava" && avalanche) ||
                    (select === "pol" && polygon)
                  }
                  alt="header icon"
                  className="h-[20px] w-atuo object-contain mr-[6px]"
                />
                <img
                  src={seearrow}
                  alt="header icon"
                  className={`h-[24px] w-atuo object-contain ${
                    dropDown === true ? " -rotate-90" : "rotate-90"
                  } transform `}
                />
              </div>

              {/* Coin DropDown */}

              {dropDown && (
                <div className=" bg-[#010304]/90 top-0 fixed bottom-0 left-0 right-0 z-[200] lg:bg-transparent lg:static">
                  <div className="z-[100] min-w-full lg:min-w-[260px] fixed lg:absolute transform bottom-0 left-0 lg:left-auto lg:bottom-auto lg:right-[-20px] lg:translate-x-[-8%] lg:top-[50px] bg-[#222222] rounded-t-[16px] lg:rounded-[16px] p-[8px]">
                    <div
                      onClick={() => {
                        setDropdown(false);
                      }}
                      className=" bg-[#383838] max-w-[32px] h-[5px] mb-[24px] rounded-[4px] mx-auto lg:hidden"
                    ></div>
                    <ul>
                      <li
                        className="flex items-center py-[8px] px-[6px] justify-between hover:bg-[#2f2f2f] rounded-[8px] cursor-pointer"
                        onClick={() => {
                          setSelect("eth");
                        }}
                      >
                        <div className="flex items-center">
                          <img
                            src={header_rhs_1}
                            alt="logo"
                            className="h-[20px] w-atuo object-contain mr-[12px]"
                          />
                          <p className="text-[14px] text-white aeonik_medium leading-[21px]">
                            Ethereum
                          </p>
                        </div>
                        {select === "eth" && (
                          <img
                            src={ckeck}
                            alt="check"
                            className="h-[20px] w-atuo object-contain"
                          />
                        )}
                      </li>
                      {/* <li
                      className="flex items-center justify-between py-[8px] px-[6px] hover:bg-[#2f2f2f] rounded-[8px] cursor-pointer"
                      onClick={() => {
                        setSelect("ava");
                      }}
                    >
                      <div className="flex items-center">
                        <img
                          src={avalanche}
                          alt="logo"
                          className="h-[20px] w-atuo object-contain mr-[12px]"
                        />
                        <p className="text-[14px] text-white aeonik_medium leading-[21px]">
                          Avalanche
                        </p>
                      </div>
                      {select === "ava" && (
                        <img
                          src={ckeck}
                          alt="check"
                          className="h-[20px] w-atuo object-contain"
                        />
                      )}
                    </li>
                    <li
                      className="flex items-center justify-between py-[8px] px-[6px] hover:bg-[#2f2f2f] rounded-[8px] cursor-pointer"
                      onClick={() => {
                        setSelect("arb");
                      }}
                    >
                      <div className="flex items-start">
                        <img
                          src={arbitrum}
                          alt="logo"
                          className="h-[20px] w-atuo object-contain mr-[12px]"
                        />
                        <p className="text-[14px] text-white aeonik_medium leading-[21px]">
                          Arbitrum
                        </p>
                      </div>
                      {select === "arb" && (
                        <img
                          src={ckeck}
                          alt="check"
                          className="h-[20px] w-atuo object-contain"
                        />
                      )}
                    </li>

                    <li
                      className="flex items-center justify-between py-[8px] px-[6px] hover:bg-[#2f2f2f] rounded-[8px] cursor-pointer"
                      onClick={() => {
                        setSelect("pol");
                      }}
                    >
                      <div className="flex items-center">
                        <img
                          src={polygon}
                          alt="logo"
                          className="h-[20px] w-atuo object-contain mr-[12px]"
                        />
                        <p className="text-[14px] text-white aeonik_medium leading-[21px]">
                          Polygon
                        </p>
                      </div>
                      {select === "pol" && (
                        <img
                          src={ckeck}
                          alt="check"
                          className="h-[20px] w-atuo object-contain"
                        />
                      )}
                    </li> */}
                    </ul>
                  </div>
                </div>
              )}
            </div>
            <div
              className="relative lg:py-[6px] lg:pl-[6px] lg:pr-[16px] rounded-[24px] lg:bg-[#2A2B2C] cursor-pointer"
              ref={popupRef_2}
            >
              <div onClick={headerDropDown_2} className=" flex items-center ">
                <img
                  src={header_rhs_2}
                  alt="header logo"
                  className="h-[24px] w-auto hidden lg:flex object-contain mr-[8px]"
                />
                <img
                  src={mobilecrypto}
                  alt="mobilecrypto"
                  className="lg:hidden"
                  onClick={headerDropDown_2}
                ></img>

                <p className="text-[16px] text-white aeonik_medium leading-[24px]">
                  {address
                    ? `${address.substring(0, 6)}...${address.substring(
                        address.length - 4
                      )}`
                    : ""}
                </p>
              </div>

              {/* Login DropDown */}

              {dropDownCopy && (
                <div className=" bg-[#010304]/90 top-0 fixed bottom-0 left-0 right-0 z-[200] lg:bg-transparent lg:static">
                  <div className="z-[100] min-w-full lg:min-w-[360px] fixed lg:absolute transform bottom-0 left-0 lg:bottom-auto lg:left-auto lg:right-[-35px] lg:translate-x-[-10%] lg:top-[50px] bg-[#222222] rounded-t-[16px] md:rounded-[16px] pt-[8px] md:pt-[16px] pb-[16px] px-[16px]">
                    <div
                      onClick={() => {
                        setDropdownCopy(false);
                        document.body.style.overflow = "auto"; // Enable scrolling
                      }}
                      className=" bg-[#383838] max-w-[32px] h-[5px] mb-[24px] rounded-[4px] mx-auto lg:hidden"
                    ></div>

                    <div className="pb-[24px] border-b-[1px] border-b-[#383838]">
                      <div className="flex items-center">
                        <img
                          src={header_rhs_2}
                          alt="header logo"
                          className="h-[40px] w-atuo object-contain mr-[12px]"
                        />
                        <p className="text-[14px] text-white aeonik_medium leading-[21px] mr-[8px]">
                          {address
                            ? `${address.substring(0, 6)}...${address.substring(
                                address.length - 4
                              )}`
                            : ""}
                        </p>
                        <img
                          src={copy}
                          alt="header logo"
                          className="h-[16px] w-atuo object-contain "
                          onClick={(e) => copyToClipBoard(address)}
                        />
                        {copySuccess && (
                          <p className=" text-[14px] text-white ml-2">
                            {copySuccess}
                          </p>
                        )}
                      </div>
                      <p className="text-[24px] text-white aeonik_medium leading-[30px] mt-[16px]">
                        $
                        {Number(
                          Number(pikuBalance * pikuPrice) + Number(usdcBalance)
                        ).toFixed(2)}
                      </p>
                    </div>
                    <div>
                      <div className="flex items-center justify-between mt-[24px]">
                        <div className="flex items-center">
                          <img
                            src={piku}
                            alt="logo"
                            className="h-[40px] w-atuo object-contain mr-[8px]"
                          />
                          <div>
                            <p className="text-[14px] text-white aeonik_medium leading-[21px]">
                              Piku
                            </p>
                            <p className="text-[14px] text-[#909090] aeonik_normal leading-[21px]">
                              {Number(pikuBalance).toFixed(2)}
                            </p>
                          </div>
                        </div>
                        <p className="text-[16px] text-white aeonik_medium leading-[20px]">
                          ${Number(pikuBalance * pikuPrice).toFixed(2)}
                        </p>
                      </div>
                      <div className="flex items-center justify-between mt-[24px]">
                        <div className="flex items-center">
                          <img
                            src={usdc}
                            alt="logo"
                            className="h-[40px] w-atuo object-contain mr-[8px]"
                          />
                          <div>
                            <p className="text-[14px] text-white aeonik_medium leading-[21px]">
                              USD Coin
                            </p>
                            <p className="text-[14px] text-[#909090] aeonik_normal leading-[21px]">
                              {Number(usdcBalance).toFixed(2)} USDC
                            </p>
                          </div>
                        </div>
                        <p className="text-[16px] text-white aeonik_medium leading-[20px]">
                          ${Number(usdcBalance).toFixed(2)}
                        </p>
                      </div>
                      {/* <div className="flex items-center justify-between mt-[24px]">
                      <div className="flex items-center">
                        <img
                          src={usdt}
                          alt="logo"
                          className="h-[40px] w-atuo object-contain mr-[8px]"
                        />
                        <div>
                          <p className="text-[14px] text-white aeonik_medium leading-[21px]">
                            Tether USD
                          </p>
                          <p className="text-[14px] text-[#909090] aeonik_normal leading-[21px]">
                            120.98 USDT
                          </p>
                        </div>
                      </div>
                      <p className="text-[16px] text-white aeonik_medium leading-[20px]">
                        $120.98
                      </p>
                    </div> */}
                    </div>
                    <a
                      onClick={() => {
                        disconnect();
                        // localStorage.removeItem("user");
                        localStorage.removeItem("kycdetail");
                        history("/");
                        setDropdownCopy(false);
                      }}
                      className="w-full cursor-pointer h-[44px] lg:h-[51px] flex items-center justify-center bg-[#382827] rounded-[150px] mt-[24px]"
                    >
                      <span className="lg:text-[18px] aeonik_medium leading-[27px] text-[#E6584D]">
                        {translation.Disconnect}
                      </span>
                    </a>
                  </div>
                </div>
              )}
            </div>

            {/* <img
              src={mobilecrypto}
              alt="mobilecrypto"
              className="lg:hidden"
            ></img> */}
            <img
              src={menu}
              alt="menu"
              className=" ml-[12px] lg:hidden"
              onClick={() => handleopenSidebar()}
            ></img>
          </div>
        ) : (
          <a
            onClick={() => open()}
            className="cursor-pointer text-black rounded-[150px] py-[12px] px-[25px] text-[18px] aeonik_medium bg-sky block"
          >
            {translation.ConnectWallet}
          </a>
        )}

        {/* mobile sidebar */}

        <div
          className={`sidebar ${
            openSidebar ? "open bg-[#010304]/90" : "bg-[#010304]/90"
          }`}
        >
          <div className="flex items-center justify-between py-[10px] bg-[#010304]">
            <Link to="/">
              <img
                src={logo}
                alt="logo"
                className="cursor-pointer"
                onClick={() => handlecloseSidebar()}
              ></img>
            </Link>
            <img
              src={sidebarcross}
              alt="logo"
              className="cursor-pointer"
              onClick={() => handlecloseSidebar()}
            ></img>
          </div>
          <ul className=" pl-[4px] pr-[16px] mt-[25px]">
            <Link to="/overview">
              <li
                className={`text-[24px] aeonik_normal leading-[36px] py-[4px] px-[12px] cursor-pointer rounded-[12px]  ${
                  location.pathname === "/overview"
                    ? "text-[#26DDF9] bg-[#26DDF9]/10"
                    : " text-white"
                } hover:text-[#26DDF9] hover:bg-[#26DDF9]/10`}
                onClick={() => {
                  handlecloseSidebar();
                  setgovernanceMobile(false);
                }}
              >
                {translation.Overview}
              </li>
            </Link>

            <li
              onClick={() => setgovernanceMobile(false)}
              className=" text-[#fff] text-[24px] mt-2 aeonik_normal leading-[36px] py-[4px] px-[12px]"
            >
              {translation.Docs}
            </li>
            <li
              onClick={() => setgovernanceMobile(false)}
              className=" text-[#fff] text-[24px] mt-2 aeonik_normal leading-[36px] py-[4px] px-[12px]"
            >
              {translation.Community}
            </li>
            <li
              onClick={() => setgovernanceMobile(!governanceMobile)}
              className=" text-[#fff]  flex items-center text-[24px] mt-2 aeonik_normal leading-[36px] py-[4px] px-[12px]"
            >
              {translation.Governance}
              <img
                src={seearrow}
                alt="down arrow"
                className="h-[14px] ml-2 w-auto object-contain transform rotate-90 "
              />
            </li>
            <li
              className={`withdrawcontent ${
                governanceMobile ? "visible" : "hidden"
              }`}
            >
              <ul className="rounded-[16px] pl-[14px]">
                {governcelist.map((m, i) => (
                  <Link
                    to={`/governance/${m.name?.toLowerCase()}`}
                    key={i}
                    onClick={() => handlecloseSidebar()}
                  >
                    <li
                      className={`text-[14px] text-white aeonik_medium leading-[21px] rounded-[8px] px-[14px] py-[8px]  ${
                        location.pathname ===
                        `/governance/${m.name?.toLowerCase()}`
                          ? "text-white bg-[#2f2f2f]"
                          : " text-white"
                      } `}
                    >
                      {m.name}
                    </li>
                  </Link>
                ))}
              </ul>
            </li>
            <Link to={`/governance/claim`}>
              <li
                className={`text-[24px] aeonik_normal leading-[36px] py-[4px] px-[12px] cursor-pointer rounded-[12px]  ${
                  location.pathname === "/governance/claim"
                    ? "text-[#26DDF9] bg-[#26DDF9]/10"
                    : " text-white"
                } hover:text-[#26DDF9] hover:bg-[#26DDF9]/10 mt-2`}
                onClick={() => {
                  handlecloseSidebar();
                  setgovernanceMobile(false);
                }}
              >
                Claim
              </li>
            </Link>
          </ul>
          {!isConnected && (
            <a
              onClick={() => open()}
              className="cursor-pointer text-black rounded-[150px] py-[8px] px-[25px] mt-[32px] text-center text-[16px] aeonik_medium bg-sky block"
            >
              {translation.ConnectWallet}
            </a>
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
